import { Container, IconTile, SectionHeading } from "./primitives";

const PILLARS = [
  { icon: "lucide:lock",      title: "End-to-End Encryption",  body: "AES-256 encryption at rest. TLS 1.3 in transit. Keys you control." },
  { icon: "lucide:shield",    title: "Granular Access Controls", body: "Category-level sharing with expiration dates and one-click revocation." },
  { icon: "lucide:file-text", title: "Complete Audit Trails",  body: "Every record view, share, and modification is logged with timestamp and identity." },
  { icon: "lucide:eye",       title: "You Own Your Data",      body: "We never sell, rent, or share your health data. Export or delete everything, anytime." },
];

export function SecuritySection() {
  return (
    <section id="security" className="scroll-mt-[68px] bg-white pt-[88px] pb-20 lg:pt-[110px] lg:pb-[100px]">
      <Container>
        <SectionHeading
          eyebrow="Security & Privacy"
          title={<>Built on accountability,<br />not just compliance</>}
        />

        <div className="mt-14 grid gap-[21px] md:grid-cols-2 lg:grid-cols-4">
          {PILLARS.map(p => (
            <article key={p.title} className="flex min-h-[232px] flex-col items-center rounded-2xl border border-[#E8E9EE] bg-white px-6 pt-7 pb-6 text-center">
              <IconTile
                icon={p.icon}
                className="h-[52px] w-[52px] rounded-xl bg-[#F3F4F8]"
                iconClassName="h-5 w-5 text-[#120240]"
              />
              <h3 className="!mt-[22px] text-[17px] font-bold tracking-[-0.015em] text-[#120240]">{p.title}</h3>
              <p className="!mt-3 max-w-[220px] text-[14px] leading-[23px] text-[#6B7280]">{p.body}</p>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
